import { SapBudgetIncreaseSnapshot } from '@/components/Approval/@components/SapBudgetIncrease';
import { parseSapBudgetIncreaseContent } from '@/utils/approval/sapBudgetIncrease';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 187 SAP 예산증액 신청 — 저장 content 그대로(레거시 문서 포함). SAP 재조회 안 함 */
const SapBudgetIncreaseSlot = ({ data }: ContentExtraProps) => {
  const content = parseSapBudgetIncreaseContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SapBudgetIncreaseSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SapBudgetIncreaseSlot;
